import { forwardRef } from 'react';

export interface RadioProps {
  /** Label */
  label?: string;
  /** Title on label */
  title?: string;
  /** Name */
  name?: string;
  /** Value */
  value?: string;
  /** Whether the radio button is selected */
  selected?: boolean;
  /** Whether the radio button is disabled */
  disabled?: boolean;
  /** Whether the radio button is required */
  required?: boolean;
  /** Whether the radio has an error */
  error?: boolean;
  /** Small */
  small?: boolean;
  /** Optional on change handler */
  onChange?: (selected: boolean) => void;
  /** Additional class */
  className?: string;
}

/** A radio button */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      label,
      title,
      name,
      value,
      selected = false,
      disabled,
      error,
      small,
      onChange,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <label
        className={['radio', small && 'radio--small', className]
          .filter(Boolean)
          .join(' ')}
        data-error={error ? '1' : undefined}
        title={title}
      >
        <input
          ref={ref}
          className="radio__input"
          type="radio"
          name={name}
          value={value}
          disabled={disabled}
          checked={selected}
          autoComplete="off"
          onChange={(e) => onChange?.(e.target.checked)}
          {...props}
        />
        <span className="radio__label">{label}</span>
      </label>
    );
  },
);
